var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"organisation-details-rating-info",class:{ 'on-search': _vm.onSearch }},[_vm._l((5),function(n){return _c('div',{key:n,staticClass:"organisation-details-rating-info-stars"},[_c('i',{class:{
        'fa fa-star fa-2x fa-lg': n <= _vm.organisationRatingValue,
        'fa fa-star-o fa-2x fa-lg': n > _vm.organisationRatingValue,
        'color-white': _vm.onSearch
      }})])}),(_vm.statusText)?_c('div',{staticClass:"organisation-details-rating-info-text"},[_vm._v(" ("+_vm._s(_vm.ratingTextValue)+") ")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }